// extracted by mini-css-extract-plugin
module.exports = {"monospace":"code__monospace___3R4r3"};